<template>
  <div style="background-color: #f9f9f9; min-height: 100vh">
    <div class="topBiaoTi">{{ demand.name }}</div>
    <div class="mid">
      <div
        style="display: flex; justify-content: space-between; flex-wrap: wrap"
      >
        <div class="li">
          发布人：<span>{{ demand.nickName }}</span>
        </div>
        <div class="li">
          联系方式：<span>{{ demand.phone }}</span>
        </div>
      </div>
      <div
        style="display: flex; justify-content: space-between; flex-wrap: wrap"
      >
        <div class="li">
          需求类型：<span>{{ demand.demandName }}</span>
        </div>
        <div class="li">
          权限类型：<span>{{ demand.authName }}</span>
        </div>
      </div>
      <div
        style="display: flex; justify-content: space-between; flex-wrap: wrap"
      >
        <div class="li">
          价格：<span>{{ demand.price }}</span
          >元
        </div>
        <div class="li">
          <span>{{ demand.create_time }}</span>
        </div>
      </div>
    </div>
    <div v-for="(item, index) in List" :key="index">
      <div class="mid1">
        <div
          style="
            display: flex;
            justify-content: space-between;
            align-items: center;
            margin-bottom: 10px;
          "
        >
          <div class="title1" v-if="item.status == 1">待确认</div>
          <div class="title1" v-if="item.status == 2">已确认</div>
          <div class="title1" v-if="item.status == 3">已完成</div>
          <div class="title1" v-if="item.status == 4">已取消</div>
          <span style="font-size: 12px">{{ item.createTime }} </span>
        </div>
        <div class="li1" @click="handleComment(item)">
          <div class="nickName1" style="font-size: 16px">
            <span>{{ item.nickName }}</span>
            <span style="font-size: 13px; color: #666">{{ item.phone }}</span>
          </div>
          <div
            v-if="item.content"
            class="content1 van-ellipsis--l2"
            v-html="item.content"
          ></div>
        </div>
        <!-- <div style="display: flex; justify-content: space-around">
              <button
                class="grabbing"
                style="
                  width: 48%;
                  background-color: #f7f7f7;
                  border-color: #eee;
                  color: #999;
                "
              >
                取消
              </button>
              <button
                class="grabbing"
                style="width: 48%"
                @click="handelConfirm(item)"
              >
                确认
              </button>
            </div> -->
      </div>
    </div>

    <div class="mid" v-if="demand.content || demand.img">
      <div class="content" v-if="demand.content">
        <div v-html="demand.content"></div>
      </div>
      <div class="img" v-if="demand.img">
        <img
          style="width: 100%"
          v-for="(item, index) in demand.img.split(',')"
          :key="index"
          :src="item"
          alt=""
          @click="showImagePreview(index, demand.img.split(','))"
          @change="onChangeImg"
        />
      </div>
    </div>
    <!-- 预览轮播图 -->
    <van-image-preview
      v-model="ImagePreviewShow"
      :images="ImgsList"
      :start-position="this.current"
      @change="onChangeImagePreview"
      @close="closeImagePreview"
    >
    </van-image-preview>
  </div>
</template>

<script>
import { getPlatform, getUrl, getStoreId, getOpenId } from "@/utils/auth";
import { getDemandType, OrderGrabbing, getDemandList } from "@/api/demand.js";
export default {
  // 组件名称
  name: "",
  // 组件参数 接收来自父组件的数据
  props: {},
  // 局部注册的组件
  components: {},
  // 组件状态值
  data() {
    return {
      List: [],
      id: "", // 需求id
      demand: {},
      url: "",
      ImgsList: [],
      ImagePreviewShow: false,
      index: 0,
      current: 0,
    };
  },
  // 计算属性
  computed: {},
  // 侦听器
  watch: {},
  // 组件方法
  methods: {
    /** 抢单人历史评价 */
    handleComment(row) {
      console.log(row);
      this.gotoUrl("/demand/historyComment/" + row.userId);
    },
    // 跳转
    gotoUrl(path) {
      if (window.__wxjs_environment === "miniprogram") {
        // 页面 不会重新加载
        window.wx.miniProgram.navigateTo({
          url: "../public/goto?path=" + path,
        });
      } else {
        // 页面会 重新加载(如:列表页 查看详情后会返回顶部)
        this.$router.push(path);
      }
    },
    // 获取订单列表
    getOrderList() {
      var grabbingId = "";
      if (getStoreId() && getStoreId() != "null") {
        grabbingId = getStoreId();
      } else {
        grabbingId = getOpenId();
      }
      var str = getUrl();
      this.url = getUrl().slice(0, str.length - 1);
      OrderGrabbing({
        demandId: this.id,
        pageSize: 10,
        pageNum: 999,
        platformId: getPlatform(),
        url: this.url,
      }).then((res) => {
        if (res.data.code == 200) {
          console.log(res);
          let rows = res.data.data.list;
          this.List = this.List.concat(rows);
          console.log(this.List);
          this.loading = false;
          if (!res.data.data.hasNextPage) {
            // 加载结束 => 没有下一页
            console.log("结束");
            this.finished = true;
          } else {
            this.finished = false;
          }
        } else {
          this.finished = true;
        }
      });
    },
    //得到图片索引值
    onChangeImg(index) {
      this.index = index;
    },
    //显示预览图
    showImagePreview(index, arr) {
      this.ImgsList = arr;
      this.ImagePreviewShow = true;
      this.current = index;
    },
    onChangeImagePreview(index) {
      this.index = index;
    },
    //关闭预览图
    closeImagePreview(info) {
      this.current = info.index;
    },
    // 获取需求详情
    async getList() {
      var str = getUrl();
      this.url = getUrl().slice(0, str.length - 1);
      const res = await getDemandList({
        pageNum: 1,
        pageSize: 10,
        platformId: getPlatform(),
        id: this.id,
        url: this.url,
      });
      this.demand = res.data.data.list[0];
    },
  },
  created() {
    this.id = this.$route.params.id;
  },
  mounted() {
    this.getList();
    this.getOrderList();
  },
};
</script> 

<style scoped>
.topBiaoTi {
  margin: 0 auto;
  width: 95%;
  box-sizing: border-box;
  padding: 15px 0;
  text-align: center;
  font-size: 16px;
  font-family: PingFang SC;
  font-weight: bold;
  color: #000000;
}

.time {
  margin: 0 auto;
  margin-right: 30px;
  margin-bottom: 15px;
  width: 95%;
  text-align: right;
  font-size: 12px;
  font-family: PingFang SC;
  font-weight: 400;
  color: #999999;
}
.content {
  margin: 0 auto;
  width: 95%;
  /* height: 50vh; */
  display: flex;
  /* justify-content: center; */
  align-items: center;
}

.img {
  margin: 0 auto;
  width: 95%;
  margin-top: 10px;
}

.li {
  font-size: 13px;
  font-family: PingFang SC;
  font-weight: 400;
  color: #666666;
  margin-bottom: 6px;
}

.li span {
  color: #1e1e1e;
}

.mid {
  width: 95%;
  margin: auto;
  margin-bottom: 10px;
  background-color: #fff;
  border-radius: 8px;
  box-sizing: border-box;
  padding: 15px 16px 15px;
}

.mid1 {
  width: 95%;
  margin: auto;
  margin-bottom: 10px;
  background-color: #fff;
  border-radius: 8px;
  box-sizing: border-box;
  padding: 14px 16px 7px;
}

.title1 {
  font-family: PingFang SC;
  font-weight: bold;
  font-size: 15px;
  color: #232323;
}

.li1 {
  width: 100%;
  background: #f7f7f7;
  border-radius: 8px;
  box-sizing: border-box;
  padding: 14px 12px 12px;
  position: relative;
}

.nickName1 {
  display: flex;
  justify-content: space-between;
  align-content: center;
  font-size: 14px;
  font-family: PingFang SC;
  color: #1e1e1e;
}
.content1 {
  font-size: 14px;
  color: #666;
  margin-top: 10px;
}
.van-ellipsis--l2 {
  display: -webkit-box !important;
  overflow: hidden !important;
  text-overflow: ellipsis !important;
  -webkit-line-clamp: 2 !important;
  -webkit-box-orient: vertical !important;
}
.grabbing {
  width: 100%;
  height: 35px;
  line-height: 35px;
  background: #f36e8629;
  border-radius: 17px;
  border: none;
  font-family: PingFang SC;
  font-weight: bold;
  font-size: 13px;
  color: #f36e86;
  margin-top: 15px;
  border: 1px solid #f36e86;
}
</style>
<style>
p {
  display: block;
  -webkit-margin-before: 0em;
  -webkit-margin-after: 0em;
  -webkit-margin-start: 0px;
  -webkit-margin-end: 0px;
}
</style>